import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const BackWrapper = styled.div`
  display: flex;
  margin-bottom: 12px;

  .BaSe--paragraph {
    cursor: pointer;
    :hover {
      color: ${BaSeTheme.colors.institucionais.azulSebrae75};
    }
  }
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  } ;
`;

export const FileMenagerContainer = styled.div`
  margin-top: 9px;
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  } ;
`;

export const ContentGrid = styled.div`
  .BaSe--paragraph {
    word-break: break-word;
  }

  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  } ;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 44px;
  margin-bottom: 20px;
`;

export const SelectWrapper = styled.div`
  margin: 21px 0 27px;

  .BaSe--select-options {
    position: inherit;
  }
`;

export const FullBodyLoading = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  display: grid;
  place-items: center;
  top: 0;
  left:0;
  z-index: ${BaSeTheme.stackOrder.overlay};
`;
